<template>
  <div class="pxp-cta-3 tw-py-24" :style="`background-color: var(--c-${vars.backgroundColor});`">
    <div class="container">
      <div class="tw-w-full">
        <div class="tw-mb-16 tw-flex tw-flex-col tw-items-center tw-self-center tw-text-center">
          <div v-if="vars.titleHtml" v-html="vars.titleHtml"></div>
        </div>
        <div class="tw-w-full !tw-text-white">
          <Swiper
            @slideChange="onSlideChange"
            @swiper="onSwiper"
            :pagination="false"
            :centered-slides="true"
            :center-insufficient-slides="true"
            :space-between="15"
            effect="fade"
            :loop="true"
            :clickable="true"
            :breakpoints="{
              320: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              640: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 30,
              },
              1536: {
                slidesPerView: 6,
                spaceBetween: 40,
              },
            }"
            class="social-swiper tw-w-full tw-self-center"
          >
            <SwiperSlide v-for="(post, index) in instagram_posts?.content_list" :key="post.id || index">
              <div
                v-if="post.is_deleted === false && post.is_hidden === false"
                @click="openPopup(post, true)"
                class="no-hover shine-effect tw-group tw-relative tw-basis-1/3 tw-overflow-hidden tw-transition-all tw-duration-500 hover:tw-cursor-pointer"
              >
                <LibraryImage
                  :w-ratio="9"
                  :h-ratio="16"
                  :src="post.thumbnail_url"
                  style="border-radius: var(--rounded)"
                />

                <video
                  v-if="post.media_type === 'VIDEO'"
                  :src="post.media_url"
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-100"
                  style="border-radius: var(--rounded)"
                  muted
                  loop
                  autoplay
                  playsinline
                ></video>

                <div
                  class="shine tw-absolute tw-inset-0 tw-opacity-0 tw-transition-opacity tw-duration-500 group-hover:tw-opacity-30"
                  style="border-radius: var(--rounded)"
                ></div>
              </div>
            </SwiperSlide>
          </Swiper>
          <div class="tw-mt-10">
            <LibrarySliderPagination
              :swiper="swiper"
              variant="v6"
              :can-paginate-back="canPaginateBack"
              :can-paginate-next="canPaginateNext"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <MotionGroup :preset="vars.animationText ? vars.animationText : 'popVisible'" :duration="400" is="div">
    <popup v-if="selectedPost && popupConfig.isActive" :config="popupConfig" custom-width="60%">
      <template #content>
        <div class="popup-container tw-grid tw-grid-cols-12 max-lg:tw-pt-6 lg:tw-overflow-y-hidden">
          <!-- Video Section -->
          <div class="video-section tw-relative tw-col-span-12 lg:tw-col-span-5">
            <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
              <video
                v-if="selectedPost.media_type?.toLowerCase() === 'video'"
                :src="selectedPost.media_url"
                class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
                style="border-radius: var(--rounded)"
                muted
                autoplay
                loop
                playsinline
                controls
              ></video>
              <img
                v-else
                :src="selectedPost.thumbnail_url"
                alt="Post thumbnail"
                class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
              />
            </div>
          </div>

          <!-- Caption Section -->
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-overflow-y-auto max-lg:tw-mt-4 lg:tw-col-span-7 lg:tw-p-8">
            <div class="tw-flex tw-flex-col">
              <div class="tw-w-24">
                <LibraryImage
                  :src="company.light_logo"
                  :h-ratio="variants.v1 === variant ? 1 : 1"
                  :w-ratio="variants.v1 === variant ? 1 : 1.2"
                />
              </div>
              <!-- <h4>{{ company.name }}</h4> -->
            </div>
            <br />
            <p class="tw-mb-4">{{ selectedPost.caption }}</p>
            <nuxt-link :to="selectedPost.permalink" target="_blank" class="n-link tw-cursor-pointer">
              <svg
                fill="var(--c-primary)"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="28px"
                height="28px"
                viewBox="0 0 169.063 169.063"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752
		c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407
		c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752
		c17.455,0,31.656,14.201,31.656,31.655V122.407z"
                  />
                  <path
                    d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561
		C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561
		c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z"
                  />
                  <path
                    d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78
		c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78
		C135.661,29.421,132.821,28.251,129.921,28.251z"
                  />
                </g>
              </svg>
            </nuxt-link>
          </div>
        </div>
      </template>
    </popup>
  </MotionGroup>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import Popup from '~/components/common/popup/Popup.vue';

export default defineNuxtComponent({
  components: { Popup },

  mixins: [ComponentMixin],

  data() {
    return {
      selectedPost: null,
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      popupConfig: {
        isActive: false,
      },
      isVisible: false,
      instagram_posts: null,
    };
  },

  computed: {
    displayPosts() {
      // Use Instagram posts if available, otherwise use dummy posts
      const instagramPosts = this.instagram_posts?.content_list;
      return instagramPosts && instagramPosts.length > 0 ? instagramPosts : this.dummyPosts;
    },
  },

  methods: {
    openPopup(post = null, value = false) {
      if (post) {
        this.selectedPost = post;
        this.popupConfig.isActive = value;
      }
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (this.variant === 'v2') {
        if (!this.swiper) return;
        const isAtStart = this.swiper.isBeginning;
        const isAtEnd = this.swiper.isEnd;
        if (isAtStart) this.canPaginateBack = false;
        else this.canPaginateBack = true;
        if (isAtEnd) this.canPaginateNext = false;
        else this.canPaginateNext = true;
      } else if (this.variant === 'v1') {
        if (!this.swiper) return;
        this.canPaginateBack = true;
        this.canPaginateNext = true;
      }
    },
  },
  created() {
    // Try to parse Instagram posts, but don't fail if not available
    try {
      this.instagram_posts = this.parseFormV2(this.vars.socialInstagramPosts);
    } catch (error) {
      console.warn('Instagram posts not available, using dummy data:', error);
      this.instagram_posts = null;
    }
  },
  mounted() {
    this.onSlideChange();
  },
});
</script>

<style scoped>
.swiper-custom ::v-deep(.swiper-wrapper) {
  align-items: center;
}

iframe {
  width: 100% !important;
  max-width: 100% !important;
  margin: 10px 0 10px 0;
}

.left-arrow,
.right-arrow {
  position: absolute;
}

.left-arrow {
  left: 10px;
  z-index: 10;
}

.right-arrow {
  right: 10px;
  z-index: 10;
}

.left-arrow svg path,
.right-arrow svg path {
  transition: all 0.3s;
}

.left-arrow:hover,
.right-arrow:hover {
  cursor: pointer;
}

.left-arrow:hover svg path,
.right-arrow:hover svg path {
  stroke: var(--c-primary);
}

::-webkit-scrollbar {
  width: 2px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: var(--c-primary);
}
::-webkit-scrollbar-thumb:window-inactive {
  display: none;
}

@media (min-width: 1080px) {
  .left-arrow,
  .right-arrow {
    position: relative;
  }

  .left-arrow {
    padding-right: 18px;
  }

  .right-arrow {
    padding-left: 18px;
  }
}

@media (min-width: 700px) and (max-width: 1400px) {
  ::v-deep(.pm-modal-wrapper) {
    width: 95% !important;
  }
}

@media (min-width: 1401px) {
  ::v-deep(.pm-modal-wrapper) {
    width: 60% !important;
  }
}
</style>
